import { render, staticRenderFns } from "./SimilarPatientsAction.vue?vue&type=template&id=77ad5d86&"
import script from "./SimilarPatientsAction.vue?vue&type=script&lang=js&"
export * from "./SimilarPatientsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports